/** Where the clips are posted, and how long each platform lets a short-form upload run (seconds, 2026):
 *  YouTube Shorts 3 min, Instagram Reels 3 min, Facebook Reels 90 s, TikTok 10 min, X 2 min 20 s on a standard account. Editable in Settings when a platform changes its rules. */
import { PLATFORMS, type Platform } from "./clip.js";
export const PLATFORM_NAMES: Record<Platform, string> = { youtube: "YouTube Shorts", instagram: "Instagram Reels", facebook: "Facebook Reels", tiktok: "TikTok", x: "X" };
export const PLATFORM_LIMITS: Record<Platform, number> = { youtube: 180, instagram: 180, facebook: 90, tiktok: 600, x: 140 };

export type PlatformFlags = Partial<Record<Platform, boolean>>;
export type PlatformLimits = Partial<Record<Platform, number>>;

/** The longest a clip may run so that it fits every platform it is posted to: the tightest limit among the enabled ones. */
export function lengthCapSec(enabled: PlatformFlags, limits: PlatformLimits = {}): { sec: number; by: Platform | null } {
  let best: { sec: number; by: Platform | null } = { sec: Infinity, by: null };
  for (const p of PLATFORMS) {
    if (enabled[p] === false) continue;
    const lim = limits[p] ?? PLATFORM_LIMITS[p];
    if (lim < best.sec) best = { sec: lim, by: p };
  }
  return best.by ? best : { sec: PLATFORM_LIMITS.facebook, by: "facebook" };
}

/** Which of the enabled platforms a clip of `sec` seconds fits, and which it is too long for. */
export function platformFit(sec: number, enabled: PlatformFlags, limits: PlatformLimits = {}): { ok: Platform[]; over: Platform[] } {
  const ok: Platform[] = [], over: Platform[] = [];
  for (const p of PLATFORMS) {
    if (enabled[p] === false) continue;
    (sec <= (limits[p] ?? PLATFORM_LIMITS[p]) ? ok : over).push(p);
  }
  return { ok, over };
}
